// Desktop header dropdowns on hover: the Swim Caps mega menu ([data-scm]) and, with style A2,
// the theme's own megamenu strips ([data-hover-menu], snippets/desktop-megamenu.liquid).
// The compiled megamenu.js in app.js only toggles .has-megamenu items on click, stops click
// propagation inside them, and rewrites the label's href when it opens one; label clicks on
// [data-hover-menu] items are therefore kept from reaching it, and outside clicks are caught
// in the capture phase.
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-scm], [data-hover-menu]'));
  if (!items.length) return;

  var canHover = window.matchMedia('(hover: hover)');

  function closeOldMenus() {
    document.querySelectorAll('.has-megamenu.show').forEach(function (menu) {
      menu.classList.remove('show');
      var toggle = menu.querySelector('.dropdown-toggle');
      var panel = menu.querySelector('.megamenu');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.classList.remove('show');
    });
  }

  function setup(item) {
    var isScm = item.hasAttribute('data-scm');
    var trigger = item.querySelector(isScm ? '.scm__trigger' : '.dropdown-toggle');
    var panel = item.querySelector(isScm ? '.scm__panel' : '.megamenu');
    var isLink = trigger.tagName === 'A' && trigger.getAttribute('href') !== '#';
    var closeTimer = null;
    var allowNavigate = true;
    var skipNextFocusOpen = false;

    function open() {
      clearTimeout(closeTimer);
      if (item.classList.contains('show')) return;
      items.forEach(function (other) {
        if (other !== item && other.scmClose) other.scmClose();
      });
      closeOldMenus();
      item.classList.add('show');
      if (!isScm) panel.classList.add('show');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      clearTimeout(closeTimer);
      item.classList.remove('show');
      if (!isScm) panel.classList.remove('show');
      trigger.setAttribute('aria-expanded', 'false');
    }
    item.scmClose = close;

    item.addEventListener('mouseenter', function () {
      if (canHover.matches) open();
    });
    item.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 150);
    });

    item.addEventListener('focusin', function () {
      if (skipNextFocusOpen) {
        skipNextFocusOpen = false;
        return;
      }
      open();
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) close();
    });

    // Window capture phase: Bootstrap's dropdown key handler (document, capture) would otherwise
    // see Escape first inside the .dropdown-menu strips, stop it and throw.
    window.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape' || !item.classList.contains('show') || !item.contains(event.target)) return;
        event.stopPropagation();
        close();
        if (document.activeElement !== trigger) {
          skipNextFocusOpen = true;
          trigger.focus();
        }
      },
      true
    );

    if (isLink) {
      // Touch: first tap opens the panel, second tap follows the link.
      trigger.addEventListener('pointerdown', function (event) {
        allowNavigate = event.pointerType === 'mouse' || item.classList.contains('show');
      });
      trigger.addEventListener('click', function (event) {
        if (!isScm) event.stopPropagation();
        if (!allowNavigate) {
          event.preventDefault();
          open();
        }
        allowNavigate = true;
      });
    } else {
      // Label with no landing page (e.g. Discover): a plain toggle.
      trigger.addEventListener('click', function (event) {
        if (!isScm) {
          event.stopPropagation();
          event.preventDefault();
        }
        if (item.classList.contains('show') && !canHover.matches) close();
        else open();
      });
    }
  }

  items.forEach(setup);

  document.addEventListener(
    'click',
    function (event) {
      items.forEach(function (item) {
        if (!item.contains(event.target) && item.scmClose) item.scmClose();
      });
    },
    true
  );
})();
